import { type SVGProps } from 'react';

/**
 * The VITNESS brand mark (Logo v7). A single-colour vector: every path is filled
 * with `color` (default `currentColor`) so the parent controls the fill — black
 * on an accent chip in the nav, or inheriting text colour elsewhere. The source
 * artwork's drop shadow and (black) gradients are intentionally flattened to one
 * solid colour so it stays crisp and recolourable at any size. The viewBox is
 * cropped to the mark's bounding box so it sits centred with no shadow padding.
 *
 * Lives in `@vitness/ui` so every layer (layouts, marketing, auth) shares one
 * canonical mark; `@vitness/marketing` re-exports it for backwards compatibility.
 */
export interface LogoMarkProps extends Omit<SVGProps<SVGSVGElement>, 'fill'> {
  /** Square size in pixels. Defaults to 28. */
  size?: number;
  /** Mark colour. Defaults to `currentColor`. */
  color?: string;
}

export function LogoMark({ size = 28, color = 'currentColor', ...props }: LogoMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="48 -8 624 530"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M241.571 100.464C244.367 90.1409 255.302 81.7727 265.995 81.7727H382.165C387.512 81.7727 390.712 85.9568 389.314 91.1182L299.44 422.882C298.041 428.043 292.574 432.227 287.227 432.227H171.057C160.364 432.227 153.963 423.859 156.759 413.536L241.571 100.464Z"
        fill={color}
      />
      <path
        d="M83.4411 219.618C86.2375 209.295 97.173 200.927 107.866 200.927H175.632C180.978 200.927 184.179 205.111 182.781 210.273L157.464 303.727C154.668 314.05 143.732 322.418 133.039 322.418H74.9543C64.2611 322.418 57.8596 314.05 60.656 303.727L83.4411 219.618Z"
        fill={color}
      />
      <path
        d="M555.715 191.582H652.523C657.869 191.582 661.07 195.766 659.672 200.927L642.499 264.32C632.408 301.568 592.95 331.764 554.365 331.764H517.74L555.715 191.582Z"
        fill={color}
      />
      <path
        d="M462.402 0C451.709 0 440.774 8.36822 437.977 18.6909L308.862 495.309C306.065 505.632 312.467 514 323.16 514H449.01C459.703 514 470.639 505.632 473.435 495.309L555.715 191.582L502.156 191.582L562.073 168.113L605.083 9.34545C606.481 4.1841 603.28 0 597.933 0H462.402Z"
        fill={color}
      />
    </svg>
  );
}
